import React from 'react'
import icWarning from '../../assets/svg/icons/mdi_warning-outline.svg';

const CancelPayment = () => {
    return (
        <div className='container-fluid'>
            <div className='row justify-content-center align-items-center py-2'>
                <div className='col-md-6 py-5'>
                    <div className='card bg-white border justify-content-center align-items-center'>
                        <idv className='ic-card p-3 mx-auto bg-white rounded-circle'>
                            <img width={52} height={52} src={icWarning} />
                        </idv>
                        <div className="card text-center border-0 py-5 bg-transparent">
                            <div className="card-body border-0">
                                <h2 className='text-center title my-3'>Payment Canceled</h2>
                                <p>Your payment has been canceled.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CancelPayment